import Grid from '@mui/material/Grid';
import establecimientoImg from '../../assets/images/menu/establecimiento.svg';
import prestadorImg from '../../assets/images/menu/prestador.svg';
import farmaciaImg from '../../assets/images/menu/farmacia.svg';
import Title from '../../@iosper/components/Page/Title';
import CardButton from '../../@iosper/components/Card/CardButton';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';

const Prestadores = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Title>Prestadores</Title>

      <Grid container spacing={2}>
        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Profesionales'}
            description={'Consultá los profesionales prestadores.'}
            to={'/buscar-prestadores'}
            image={prestadorImg}
            isMobile={isMobileScreen}
          />
        </Grid>

        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Establecimientos'}
            description={'Consultá los establecimientos prestadores.'}
            to={'/buscar-establecimientos'}
            image={establecimientoImg}
            isMobile={isMobileScreen}
          />
        </Grid>
        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Farmacias'}
            description={'Consultá las farmacias que trabajan con OSER.'}
            to={'/buscar-farmacias'}
            image={farmaciaImg}
            isMobile={isMobileScreen}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Prestadores;
